import React from 'react';

import {useNavigate, useParams} from "react-router-dom";
import OphtalmologistEmails from "./OphtalmologistEmails";
import LogDisplay from "../../Logs/LogDisplay";
import {User} from "../../../../Shared/Enums/Enums";

export default function Ophtalmologist({ophtalmologists}) {
    const {id} = useParams();
    const ophtalmologist = ophtalmologists.find((ophtalmologist) => ophtalmologist.id === parseInt(id))
    const nav = useNavigate();

    return (
        <div id="full-height" style={{display: "flex", flexDirection: "column", overflowY: "scroll"}}>
            <div className="valign-wrapper" style={{marginLeft: 10}}>
                <a className="btn-flat" style={{borderRadius: 20}} onClick={() => nav("/ophtalmologists")}>
                    <i className="material-icons">arrow_back</i>
                </a>
                <h3 className="valign-wrapper" style={{margin: 20}}><i className="material-icons left">preview</i>
                    Gestion de {Helper.formatName(ophtalmologist.prenom, ophtalmologist.nom)}
                </h3>
            </div>
            <div className="divider"/>
            <div>
                <h3 className="valign-wrapper" style={{paddingLeft: 20}}>
                    <i className="material-icons left">email</i>
                    Edition des templates email
                </h3>
                <OphtalmologistEmails ophtalmologist={ophtalmologist}/>
            </div>
            <div className="divider"/>
            <div className="row" style={{padding: 20, gap: 10, minHeight: 400}}>
                <div className="col s12 l6">
                    <LogDisplay user_type={User.OPHTALMOLOGIST.value} user={ophtalmologist}/>
                </div>
            </div>

        </div>
    );
}